import {
    Box,
    Card,
    CardActionArea,
    CardContent,
    CardMedia,
    Icon,
    Stack,
    Typography,
} from "@mui/material";
import { createArrayOf } from "../../../utils/array";
import DiscountCardPercentageBox from "./DiscountCardPercentageBox";

const ALREADY_GIVEN_DISCOUNT = 2;
const SERVER_MAXIMUM_DISCOUNT = 8;

const MAXIMUM_POSSIBLE_DISCOUNTS = 10;
const MINIMUM_POSSIBLE_DISCOUNTS = 0;

type TProps = {
    totalReferrals: number;
};

export default function CustomerSupportDiscountCard(props: TProps) {
    const filled = createArrayOf(
        Math.min(
            props.totalReferrals + ALREADY_GIVEN_DISCOUNT,
            MAXIMUM_POSSIBLE_DISCOUNTS
        )
    );
    const unfilled = createArrayOf(
        Math.max(
            SERVER_MAXIMUM_DISCOUNT - props.totalReferrals,
            MINIMUM_POSSIBLE_DISCOUNTS
        )
    );

    return (
        <Card
            sx={{
                background:
                    "linear-gradient(to right bottom, #36EAEF, #6B0AC9)",
                mb: 2,
            }}
        >
            <CardActionArea>
                <CardMedia
                    component="img"
                    image="/images/customer-support.png"
                    alt="customer support"
                    sx={{
                        objectFit: "contain",
                        height: { xs: "100", md: "300", lg: "472" },
                    }}
                />

                <CardContent
                    sx={{
                        color: "white",
                        width: { md: "80%" },
                        margin: "auto",
                    }}
                >
                    <Typography gutterBottom variant="h5" component="div">
                        تخفیف معرفی
                    </Typography>
                    <Stack spacing={2}>
                        <Typography variant="body1" color="whitesmoke">
                            دوستانتون رو دعوت کنید و کد تخفیف ویژه خرید اشتراک
                            بگیرید. به ازای هر دعوت موفق 10 درصد تخفیف می گیرید
                            و برای رسیدن به یک اشتراک رایگان کافیه 8 نفر رو دعوت
                            کنید.
                        </Typography>

                        <Stack direction="row">
                            <Icon sx={{ marginRight: 1 }}>star</Icon>
                            <Typography
                                variant="body2"
                                color="whitesmoke"
                                sx={{
                                    display: "flex",
                                    alignItems: { xs: "start", md: "center" },
                                }}
                            >
                                توجه داشته باشید که با استفاده از کد تخفیف قبل
                                از رسیدن به 8 نفر، کد تخفیف های شما استفاده
                                خواهد شد و باید مجدد برای رسیدن به اشتراک رایگان
                                تلاش کنید.
                            </Typography>
                        </Stack>
                    </Stack>
                </CardContent>

                <Box paddingBottom={3} padding={2}>
                    <Stack
                        direction="row"
                        justifyContent="space-around"
                        flexWrap="wrap"
                        useFlexGap
                        spacing={1}
                    >
                        {/* Filled boxes representing owned discounts */}
                        {filled.map((d) => (
                            <DiscountCardPercentageBox key={d} filled>
                                10%
                            </DiscountCardPercentageBox>
                        ))}

                        {/* Unfilled boxed representing possible discounts */}
                        {unfilled.map((d) => (
                            <DiscountCardPercentageBox key={d}>
                                10%
                            </DiscountCardPercentageBox>
                        ))}
                    </Stack>
                </Box>
            </CardActionArea>
        </Card>
    );
}
